import React, { useMemo } from 'react';

interface QA {
  question: string;
  answer: string;
}
export const FaqStructuredData: React.FC<{
  faqs: QA[];
  faqPageId?: string;
}> = ({ faqs, faqPageId }) => {
  const jsonLd = useMemo(
    () => JSON.stringify(generateStructuredData(faqs, faqPageId)),
    [faqPageId, faqs],
  );

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: jsonLd }}
    />
  );
};

export function generateStructuredData(faqs: QA[], faqPageId?: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    // should be the same id for all Faq components on a page, or the structured data will be invalid
    // since each page can only have one FAQPage definition. Referencing the same id will behave
    // as if we had one definiton for all Faqs components
    ...(faqPageId && { '@id': faqPageId }),
    mainEntity: faqs.map(({ question, answer }) => ({
      '@type': 'Question',
      name: question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answer,
      },
    })),
  };
}
